module.exports = __webpack_public_path__ + "img/mfe-logo.5682146f.png";